export const commitmentsDrawerResizingDefaultParams = {
  maxWidthPercent: 95,
  defaultWidthPercent: 70,
  minWidthPercent: 35,
  key: "commitmentsDrawer",
};
